import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppHttpService } from 'src/app/app-http.service';
import { ModalMensageComponent } from '../modal-mensage/modal-mensage.component';
import { text } from "../../../../config/text";

export interface DialogData {
  email: '';
  phone: '';
  formaEnvio: '';
  formaEnvioDigitoVerificador: '';
}

@Component({
  selector: 'app-modal-choice',
  templateUrl: './modal-choice.component.html',
  styleUrls: ['./modal-choice.component.css']
})
export class ModalChoiceComponent implements OnInit {


  constructor(private router: Router, @Inject(MAT_DIALOG_DATA) public data: DialogData, public http: AppHttpService, public dialog: MatDialog) {

  }

  email: String = '';
  phone: string = '';
  formaEnvio: string = '';
  formaEnvioDigitoVerificador: string = '';
  msg: string = '';

  ngOnInit(): void {

    this.email = this.data.email;
    this.phone = this.data.phone;
	this.formaEnvio = this.data.formaEnvio;
	this.formaEnvioDigitoVerificador = this.data.formaEnvioDigitoVerificador

  }

  goTo(pageName: string) {
    this.router.navigate([pageName]);
  }

  sendCode(pageName: string, type: number) {
    this.http.postSendVerificationCode(localStorage["userId"], type).subscribe((data: any) => {
      this.router.navigate([pageName]);
    }, ((error: any) => {
      this.msg = "";

      if (error.error.length > 0) {
        if (error.error[0].message == "MensagemErroAoEnviarCodigoVerificacao") {
          this.msg = text.erroEnvio;
        }
        else
          this.msg = text.erroApiSMS + error.error[0].message;
      }
      else {
        this.msg = error.error;
      }

      const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg: this.msg
          }
        });
    }));
  }
  
  sendEmail(pageName: string, type: number) {
    this.http.postSendVerificationCode(localStorage["userId"], type).subscribe((data: any) => {
      
	  if (type == 1)
	  {
		this.msg = text.envio_email_senha_sucesso;
	  }
	  else
	  {
		this.msg = text.envio_email_link_sucesso;
	  }
	  const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg: this.msg
          }
        });
	  dialogRef.afterClosed().subscribe(result => {
          window.location.assign(localStorage['URL_BACK']);
        });
    }, ((error: any) => {
      this.msg = "";
      
      if (error.error.length > 0) {
        if (error.error[0].message == "MensagemErroAoEnviarCodigoVerificacao") {
          this.msg = text.erroEnvio;
        }
        else
          this.msg = text.erroApiSMS + error.error[0].message;
      }
      else {
        this.msg = error.error;
      }
	  
      const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg: this.msg
          }
        });
    }));
  }









}
